module.exports = __webpack_public_path__ + "static/img/FUMIN.be9ab90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bankInfoBg/FUMIN.png
// module id = wqMN
// module chunks = 70